/// <reference path="../../../Modules/Attr/Dialog/NoboxEntityDialog.ts" />
namespace Nobox.Administration {

    @Serenity.Decorators.registerClass()
    export class UserDialog extends NoboxEntityDialog<UserRow, any> {
        protected getFormKey() { return UserForm.formKey; }
        protected getIdProperty() { return UserRow.idProperty; }
        protected getIsActiveProperty() { return UserRow.isActiveProperty; }
        protected getLocalTextPrefix() { return UserRow.localTextPrefix; }
        protected getNameProperty() { return UserRow.nameProperty; }
        protected getService() { return UserService.baseUrl; }

        protected form = new UserForm(this.idPrefix);

        private userRoleGrid: UserRoleGrid;
        constructor() {
            super();
            this.userRoleGrid = new UserRoleGrid(this.byId('UserRoleGrid'));
            this.form.Password.addValidationRule(this.uniqueName, e => {
                if (this.form.Password.value.length < 7)
                    return "Password must be at least 7 characters!";
            });

            this.form.PasswordConfirm.addValidationRule(this.uniqueName, e => {
                if (this.form.Password.value != this.form.PasswordConfirm.value)
                    return "The passwords entered doesn't match!";
            });
        }

        protected getToolbarButtons()
        {
            let buttons = super.getToolbarButtons();

            buttons.push({
                title: Q.text('Site.UserDialog.EditPermissionsButton'),
                cssClass: 'edit-permissions-button',
                icon: 'fa-lock text-green',
                onClick: () =>
                {
                    new UserPermissionDialog({
                        userID: this.entity.UserId,
                        username: this.entity.Username
                    }).dialogOpen();
                }
            });

            return buttons;
        }

        protected updateInterface() {
            super.updateInterface();

            this.toolbar.findButton('edit-roles-button').toggleClass('disabled', this.isNewOrDeleted());
            this.toolbar.findButton("edit-permissions-button").toggleClass("disabled", this.isNewOrDeleted());
        }

        protected afterLoadEntity() {
            super.afterLoadEntity();

            // these fields are only required in new record mode
            this.form.Password.element.toggleClass('required', this.isNew())
                .closest('.field').find('sup').toggle(this.isNew());
            this.form.PasswordConfirm.element.toggleClass('required', this.isNew())
                .closest('.field').find('sup').toggle(this.isNew());
        }

        loadEntity(entity: UserRoleRow) {
            super.loadEntity(entity);

            Serenity.TabsExtensions.setDisabled(this.tabs, 'Role', this.isNewOrDeleted());
            if (this.isNewOrDeleted()) {
                this.byId('UserRoleGrid').hide();
            } else {
                this.userRoleGrid.userId = `${entity.UserId}`;
                this.userRoleGrid.userName = `${entity.Username}`;
            };
        }


        protected save(e) {

            var $this = this;
            var value = this.form.Timezone.get_value();

            var valCookie = Master.TimezoneRow.getLookup().itemById[value].Name;
            if (value == null || value == undefined || value == "") {
                document.cookie = "timezone=Asia%2FJakarta; path=/";
            } else {
                document.cookie = "timezone=" + valCookie.replace('/', '%2F') + "; path=/";
            }

            //if (this.form.CtryId.value != "") {
            //    var ctryId = this.form.CtryId.value;
            //    this.form.Ctry.value = Master.CountriesRow.getLookup().itemById[ctryId].Name;
            //}

            //if (this.form.StatesId.value != "") {
            //    var statesId = this.form.StatesId.value;
            //    this.form.States.value = Master.StatesRow.getLookup().itemById[statesId].Name;
            //}

            //if (this.form.CityId.value != "") {
            //    var cityId = this.form.CityId.value;
            //    this.form.City.value = Master.CitiesRow.getLookup().itemById[cityId].Name;
            //}
            super.save(e);
        }

        protected onSaveSuccess(response) {
            super.onSaveSuccess(response);

            Serenity.SubDialogHelper.triggerDataChange(this);   // *** Refreshing the parent grid ***
            this.dialogClose();    // *** Closing the dialog ***
        }

        getTemplate() {
            return `<div id="~_Tabs" class="s-DialogContent">
                        <ul>
                            <li><a href="#~_TabUser"><span>Preference</span></a></li>
                            <li><a href="#~_TabRole"><span>Role</span></a></li>
                        </ul>
                        <div id="~_TabUser" class="tab-pane s-TabUser">
                            <div id="~_Toolbar" class="s-DialogToolbar">
                            </div>
                            <div class="s-Form">
                                <form id="~_Form" action="">
                                    <div class="fieldset ui-widget ui-widget-content ui-corner-all">
                                        <div id="~_PropertyGrid"></div>
                                        <div class="clear"></div>
                                    </div>
                                </form>
                            </div>
                        </div>
                        <div id="~_TabRole" class="tab-pane s-TabRole">
                            <div id="~_Toolbar" class="s-DialogToolbar">
                            </div>
                            <div class="s-Form">
                                <form id="~_CampaignDataForm" action="">
                                    <div class="fieldset ui-widget ui-widget-content ui-corner-all">
                                        <div id="~_UserRoleGrid"></div>
                                        <div class="clear"></div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>`;
        }
    }
    }
}